import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby code and mapped to DB values
export const replicationMethodologyOptions = [
  { value: "0", label: "Physical" },
  { value: "1", label: "Synthetical" },
];

export const distributionPolicyOptions = [
  { value: "0", label: "Accumulating" },
  { value: "1", label: "Distributing" },
];

export const sfdrOptions = [
  { value: "Article 6", label: "Article 6" },
  { value: "Article 8", label: "Article 8" },
  { value: "Article 9", label: "Article 9" },
  { value: "N/A", label: "N/A" },
];

export const filterEtfStaticDataSchema = z.object({
  benchmark_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  replication_methodology_equals: z.string().nullable().optional(),
  distribution_policy_equals: z.string().nullable().optional(),
  sfdr_equals: z.string().nullable().optional(),
});

export type FilterEtfStaticDataSchema = z.infer<
  typeof filterEtfStaticDataSchema
>;

export const fields: Field[] = [
  {
    name: "benchmark_name_contains",
    label: "Benchmark Name",
    type: "asyncAutocomplete",
    base_url: "instit-quantilia/etf_static_data",
    column_name: "benchmark_name",
  },
  {
    name: "replication_methodology_equals",
    label: "Replication Methodology",
    type: "select",
    useTranslation: false,
    options: replicationMethodologyOptions,
  },
  {
    name: "distribution_policy_equals",
    label: "Distribution Policy",
    type: "select",
    useTranslation: false,
    options: distributionPolicyOptions,
  },
  {
    name: "sfdr_equals",
    label: "SFDR",
    type: "select",
    useTranslation: false,
    options: sfdrOptions,
  },
];

export const client = "qtl - referential";

export function FilterEtfStaticData() {
  return (
    <FilterTable
      client={client}
      schema={filterEtfStaticDataSchema}
      tableName="etf_static_data"
      customBuildPath={() => `${client}/etf_static_data`}
      fields={fields}
    />
  );
}
